/*! @azure/msal-browser-1p v3.23.0 2024-09-03 */
'use strict';
import { PerformanceEvents as PerformanceEvents$1 } from '@azure/msal-browser';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Temporary solution to accommodate both 1p and 3p telemetry functionality.
 */
const PerformanceEvents = {
    ...PerformanceEvents$1,
    PairwiseBrokerApplicationInitializeBrokering: "pairwiseBrokerApplicationInitializeBrokering",
    BrokerClientApplicationHandleBrokerHandshake: "brokerClientApplicationHandleBrokerHandshake",
    BrokerClientApplicationBrokeredSSOSilentRequest: "brokerClientApplicationBrokeredSSOSilentRequest",
    BrokerClientApplicationBrokeredSilentRequest: "brokerClientApplicationBrokeredSilentRequest",
    EmbeddedClientApplicationSendSSOSilentRequest: "embeddedSSOSilent",
    EmbeddedClientApplicationSendPopupRequest: "embeddedPopup",
    EmbeddedClientApplicationSendRedirectRequest: "embeddedRedirect",
    EmbeddedClientApplicationHandleRedirectRequest: "embeddedHandleRedirect",
    EmbeddedClientApplicationSendSilentRefreshRequest: "embeddedSilentRefresh",
};
const PerformanceEventAbbreviations = new Map([
    [
        PerformanceEvents.PairwiseBrokerApplicationInitializeBrokering,
        "PWBInitBrk",
    ],
    [
        PerformanceEvents.BrokerClientApplicationHandleBrokerHandshake,
        "BrkClientHandeBrkHandshake",
    ],
    [
        PerformanceEvents.BrokerClientApplicationBrokeredSSOSilentRequest,
        "BrkClientBrkSSOReq",
    ],
    [
        PerformanceEvents.BrokerClientApplicationBrokeredSilentRequest,
        "BrkClientBrkSltReq",
    ],
    [
        PerformanceEvents.EmbeddedClientApplicationSendSSOSilentRequest,
        "EmbClientSendSSOReq",
    ],
    [
        PerformanceEvents.EmbeddedClientApplicationSendPopupRequest,
        "EmbClientSendPopupReq",
    ],
    [
        PerformanceEvents.EmbeddedClientApplicationSendRedirectRequest,
        "EmbClientSendRedirectReq",
    ],
    [
        PerformanceEvents.EmbeddedClientApplicationHandleRedirectRequest,
        "EmbClientHandleRedirectReq",
    ],
    [
        PerformanceEvents.EmbeddedClientApplicationSendSilentRefreshRequest,
        "EmbClientSendSltRefreshReq",
    ],
]);
const intFields = new Set([
    "brokerInteractionTimeoutMs",
    "brokerMessageTimeoutMs",
    "brokerHandshakeTimeoutMs",
    "brokerIframeTimeoutMs",
]);

export { PerformanceEventAbbreviations, PerformanceEvents, intFields };
//# sourceMappingURL=TelemetryUtils.mjs.map
